import React, { useCallback } from "react";
import CustomCard from '../../../../src/components/card/CustomCard';
import CustomCardHeader from '../../../../src/components/card/CustomCardHeader';
import CardBody from '../../../../src/components/card/CardBody';
import AddItemModal from "./AddItemModal";
import { useDispatch, useSelector } from "react-redux";
import { resetCurrentTab, setActiveTab , resetSearchResult} from "../../../redux/slices/dynamicUiSlice";
import AddItemTabs from "./DynamicItemTabs";
import CustomButton, { OutlinedButton, SemiTransparentButton } from "../../../components/CustomButton";
import CustomIcon from "../../../components/CustomIcon";
import { debounce } from "lodash";
import DynamicItemListContents from "./DynamicItemListContents";
import { CommonTabGroup } from "components/tab/TabGroup";
import { DYNAMIC_SECTION_TABS, SEARCH_MODE } from "../constants";
import DynamicItemSearchContents from "./DynamicItemSearchContent";

export default function DynamicItemList() {
  const [showAddItemModal, setShowAddItemModal] = React.useState();
  const dispatch = useDispatch();

  const mode = useSelector((state) => (state.dynamicUi.mode));

  // noinspection JSCheckFunctionSignatures
  const debouncedDynamicItemsReload = useCallback(debounce(() => {
    dispatch(resetCurrentTab({}));
  }, 100), [dispatch]);

  const clearSearchResult = () => {
    dispatch(resetSearchResult())
  }

  return (<>
    <CustomCard>
      <CustomCardHeader contentPosition="none">
        <div className="w-full flex items-center justify-between">
          <h2 className="text-white text-2xl">Dynamic Items</h2>
          <AddButton onAdd={() => setShowAddItemModal({})} />
        </div>
      </CustomCardHeader>
      {mode === SEARCH_MODE ?
        <CardBody>
          <DynamicItemSearchContents onEditItem={setShowAddItemModal} />
          <div className="flex justify-end">
            <CustomButton onClick={clearSearchResult}>
              Clear
            </CustomButton>
          </div>
        </CardBody>
        :
        <CardBody className="p-0">
          <SectionTab />
          <div className="flex space-x-4">
            <div className="flex-grow">
              <AddItemTabs />
            </div>
            <ReloadButton onReload={debouncedDynamicItemsReload} />
          </div>
          <DynamicItemListContents onEditItem={setShowAddItemModal} />
        </CardBody>
      }
    </CustomCard>
    <AddItemModal showModal={showAddItemModal} setShowModal={setShowAddItemModal} />
  </>);
}


const AddButton = ({ onAdd }) => {

  const activeTab = useSelector((state) => (state.dynamicUi.items.activeTab));
  const selectedTab = useSelector((state) => (state.dynamicUi.items[activeTab].selected));

  const currentPage = useSelector((state) => state.dynamicUi.items[activeTab][selectedTab].meta.page);

  const { loading = false, error = "" } = useSelector((state) => state.dynamicUi.items[activeTab][selectedTab].pageData[currentPage]) ?? {};


  return (
    loading || !!error ? <div className="animate-pulse h-10 rounded w-24 bg-rand-200" /> :
      <SemiTransparentButton
        onClick={onAdd}>
        + Add
      </SemiTransparentButton>
  );
}

const ReloadButton = ({ onReload }) => {

  const activeTab = useSelector((state) => (state.dynamicUi.items.activeTab));
  const selectedTab = useSelector((state) => (state.dynamicUi.items[activeTab].selected));

  const currentPage = useSelector((state) => state.dynamicUi.items[activeTab][selectedTab].meta.page);

  const loading = useSelector((state) => state.dynamicUi.items[activeTab][selectedTab].pageData[currentPage]?.loading) ?? false;


  return (
    !loading ? <OutlinedButton className="w-8 h-8 flex justify-center items-center"
      onClick={onReload}>

      <CustomIcon icon="refresh" size="lg" title="Reload"
      />
    </OutlinedButton> :
      <OutlinedButton className="w-8 h-8 flex justify-center items-center border-rand-300 cursor-not-allowed">

        <CustomIcon icon="refresh" size="lg" title="Reload" className="text-rand-300" />
      </OutlinedButton>
  );
}


const SectionTab = () => {
  const dispatch = useDispatch()
  const activeTab = useSelector((state) => (state.dynamicUi.items.activeTab));
  const _activeTab = DYNAMIC_SECTION_TABS.find((t) => t.value === activeTab)

  const Tab = ({ tab }) => {
    return (
      <div
        className={`${_activeTab === tab
          ? 'text-rand-100 border-secondary-500'
          : 'text-rand-200 border-transparent hover:border-rand-300 cursor-pointer'
          } focus:outline-none px-6 py-3 text-sm font-medium border-b-2`}
        onClick={() => {
          dispatch(setActiveTab(tab))
        }}
      >
        {tab.label}
      </div>
    )
  }
  return <CommonTabGroup>
    {DYNAMIC_SECTION_TABS.map((n, index) => (
      <Tab key={`${n}-${index}`} tab={n} />
    ))}
  </CommonTabGroup>
}

